import { useEffect } from 'react';
import { View } from 'foundations-components/components/View';
import useLocaleContext from '../hooks/useLocaleContext';
import { getIsAcceptanceTest } from '../utils/isAcceptanceTest';
import { jsx as _jsx } from "react/jsx-runtime";
export const SITE_KEY = '6Lcp1ngqAAAAAOT4TMori7JN6cmU2TanIFPx3NxA';
// Acceptance test site key bypasses recaptcha verification. Should ONLY be used for ATs.
// https://developers.google.com/recaptcha/docs/faq?hl=en#id-like-to-run-automated-tests-with-recaptcha.-what-should-i-do
export const TEST_SITE_KEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
const loadAndSetupRecaptchaScript = (locale, onReceiveToken) => {
  const script = document.createElement('script');
  script.src = `https://www.google.com/recaptcha/api.js?hl=${locale}`;
  script.defer = true;
  script.async = true;
  document.body.appendChild(script);
  window.onReceiveToken = onReceiveToken;
  return () => {
    document.body.removeChild(script);
  };
};

/*
 * This func retries if the captcha iframe has not loaded yet.
 * Particularly on AP1 firefox it can be slow to load.
 */
const updateCaptchaLocale = (locale, currentAttempt = 0, maxAttempts = 20) => {
  const retry = () => {
    if (currentAttempt < maxAttempts) {
      return setTimeout(() => updateCaptchaLocale(locale, currentAttempt + 1, maxAttempts), 150);
    }
    console.warn('Failed to update reCAPTCHA locale after maximum attempts');
    return;
  };
  const captchaIframe = document.querySelector('#captcha_container iframe');
  if (!(captchaIframe !== null && captchaIframe !== void 0 && captchaIframe.src)) {
    return retry();
  }
  try {
    const url = new URL(captchaIframe.src);
    const currentLocale = url.searchParams.get('hl');
    if (!currentLocale) {
      return retry();
    }
    if (currentLocale !== locale) {
      url.searchParams.set('hl', locale);
      captchaIframe.src = url.toString();
    }
  } catch (error) {
    console.error('Error updating reCAPTCHA locale:', error);
    return retry();
  }
};
function Recaptcha(props) {
  const {
    onReceiveToken
  } = props;
  const {
    locale
  } = useLocaleContext();
  const siteKey = getIsAcceptanceTest() ? TEST_SITE_KEY : SITE_KEY;
  useEffect(() => {
    loadAndSetupRecaptchaScript(locale, onReceiveToken);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onReceiveToken]);
  useEffect(() => {
    const timeoutId = updateCaptchaLocale(locale);
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [locale]);
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "800",
    children: /*#__PURE__*/_jsx("div", {
      className: "g-recaptcha",
      "data-sitekey": siteKey,
      "data-callback": "onReceiveToken",
      "data-action": "submit",
      id: "captcha_container",
      "data-test-id": "recaptcha"
    })
  });
}
export default Recaptcha;